package com.milta.feature.imports.data.repository

import com.milta.feature.imports.data.remote.ImportApi
import com.milta.feature.imports.data.remote.dto.toDomain
import com.milta.feature.imports.domain.entity.ImportResult
import com.milta.feature.imports.domain.entity.ImportType
import com.milta.feature.imports.domain.repository.ImportRepository

class ImportRepositoryImpl(private val api: ImportApi) : ImportRepository {

    override suspend fun startImport(fileBytes: ByteArray, fileName: String, importType: ImportType): ImportResult =
        api.startImport(fileBytes, fileName, importType).toDomain()

    override suspend fun retryImport(importSessionId: String, fileBytes: ByteArray, fileName: String): ImportResult =
        api.retryImport(importSessionId, fileBytes, fileName).toDomain()
}
